import {
  GET_RESULTS,
  SET_RESULTS,
  SET_RENDERED_RESULTS,
  RESET_FILTERED_RESULTS,
  SET_FILTERED_RESULTS,
  GET_SEARCH_RESULTS,
  SEARCH_BUSY,
  SEARCH_NOTBUSY,
  SET_SEARCH_TEXT,
  ERROR_RESULTS,
} from "../actions/types";
import { incrementResults } from "../constants";

const initialState = {
  all: {},
  filtered: {},
  rendered: {},
  busy: false,
  searchText: "",
  errorResults: false,
};

export const initialRender = incrementResults;

const resultReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_SEARCH_RESULTS:
    case GET_RESULTS:
      return {
        ...state,
        all: [...payload],
        filtered: [...payload],
        rendered: [...payload.slice(0, initialRender)],
      };
    case SET_RESULTS:
      return { ...state, all: payload };
    case SET_FILTERED_RESULTS:
      return { ...state, filtered: payload };
    case SET_RENDERED_RESULTS:
      return { ...state, rendered: payload };
    case RESET_FILTERED_RESULTS:
      return {
        ...state,
        filtered: [...state.all],
        rendered: [...state.all.slice(0, initialRender)],
      };
    case SEARCH_BUSY:
      return { ...state, busy: true };
    case SEARCH_NOTBUSY:
      return { ...state, busy: false };
    case SET_SEARCH_TEXT:
      return { ...state, searchText: payload };
    case ERROR_RESULTS:
      return { ...state, errorResults: true };

    default:
      return state;
  }
};

export default resultReducer;
